/**
 * Class containing constants related to EOWP_SHOP.
 * Note: All static fields in this class will be updated over time.
 */
class ShopConstants{
    static BROWSER_RECOMMENDED_VERSION_IOS = "Safari の最新版";
    static BROWSER_RECOMMENDED_VERSION_ANDROID = "Chrome の最新版";
    static BROWSER_RECOMMENDED_VERSION_WINDOWS = "Edge・Chrome・Firefoxの各最新版";
    static BROWSER_RECOMMENDED_VERSION_MACOS = "Safari・Chrome・Firefoxの各最新版";
    
    static COMPATIBLE_OS_BROWSERS_WINDOWS = "Windows：Edge、Chrome、Firefoxの各最新版";
    static COMPATIBLE_OS_BROWSERS_MACOS = "macOS：Safari、Chrome、Firefoxの各最新版";
    static COMPATIBLE_OS_BROWSERS_IOS = "iOS：Safariの最新版";
    static COMPATIBLE_OS_BROWSERS_ANDROID = "Android：Chromeの最新版";

    static FREE_TRIAL_DURATION = "2週間";

    static COURSE_MAPPING = {
        '9111620': '月額コース',
        '9111621': '年額コース',
    };

    static BILLING_MAPPING = {
        '9111620': '１カ月',
        '9111621': '１年',
    };

    static COMPANY_ADDRESS = "〒141-0001 東京都品川区北品川 6-7-29 ガーデングレイス品川御殿山 3階";
    static COMPANY_ADDRESS_RECEIPT = "〒141-0001 東京都品川区北品川 6-7-29 <br>ガーデングレイス品川御殿山 3階";

    static CANCELLATION_SURVEY_LINK = "https://forms.office.com/Pages/ResponsePage.aspx?id=tqoXtQzHMUqW4QQAN7M6caemEnKaZcFAmNXUCZKCMnBUNjBCTDU2U1VZREZZU0dWTjNCVktXREM4Ti4u";
    static CONTACT_FORM_LINK = "https://eow-support.alc.co.jp/hc/ja/requests/new";
}

export default ShopConstants;
